<template>
	<div class="sf-account-containter w-100 h-100">
		<div class="row no-gutters h-100 w-100">
			<div class="col-lg-8"></div>
			<div class="col-lg-4 sf-account-right">
				<div class="sf-account-form">
					<div class="sf-account-form__header">
						<div class="sf-account__logo">
							<div class="blind">LOGO</div>
						</div>
						<div class="sf-account__logo__title">{{ systemName }}</div>
						<!-- <p class="title hd_head-24_1">{{ systemName }}</p> -->
					</div>
					<div class="sf-account-form__contents">
						<div class="sf-account-form__item">
							<div class="col-lg-10">
								<div class="sf-account-form__title">
									<!-- 다국어: 비밀번호 재설정 -->
									<h2 class="hd_head-30_1">{{ getMessage_('SWCC000399') }} ({{ userId }})</h2>
								</div>
								<div class="sf-account-form__input">
									<span class="hd_head-18_1">{{ getMessage_('SWCC000758') }}</span>
									<el-input type="password" v-model="userPw" @keyup.enter.native="resetAction" @input="e => input(e, 'userPw')" />
								</div>
							</div>
						</div>
						<div class="sf-account-form__item">
							<div class="col-lg-10">
								<div class="sf-account-form__input">
									<!-- 다국어: 새 비밀번호 -->
									<span class="hd_head-18_1">{{ getMessage_('SWCC000771') }}</span>
									<el-input type="password" v-model="newUserPw" @keyup.enter.native="resetAction" @input="e => input(e, 'newUserPw')" />
								</div>
							</div>
						</div>
						<div class="sf-account-form__item">
							<div class="col-lg-10">
								<div class="sf-account-form__input">
									<!-- 다국어: 새 비밀번호 확인 -->
									<span class="hd_head-18_1">{{ getMessage_('SWCC000773') }}</span>
									<el-input
										type="password"
										v-model="newUserPwCheck"
										@keyup.enter.native="resetAction"
										@input="e => input(e, 'newUserPwCheck')"
									/>
								</div>
							</div>
						</div>
						<div class="sf-account-form__item">
							<div class="col-lg-10">
								<div class="sf-account-form__btn">
									<!-- 다국어: 비밀번호 재설정 -->
									<button type="button" @click="resetAction">{{ getMessage_('SWCC000399') }}</button>
								</div>
							</div>
						</div>
						<div class="sf-account-form__copyright">
							<div class="hd_text-12_1">{{ copyright }}</div>
							<div class="hd_text-12_2">{{ icpNo }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
//비밀번호 변경 페이지
import { rootComputed, rootMethods } from '@/store/common/helpers';
import * as yup from 'yup';

export default {
	data() {
		return {
			userPw: '',
			newUserPw: '',
			newUserPwCheck: ''
		};
	},

	computed: {
		...rootComputed,

		systemName() {
			return process.env.VUE_APP_SYSTEM_NAME;
		},

		copyright() {
			return process.env.VUE_APP_COPYRIGHT;
		},

		icpNo() {
			return process.env.VUE_APP_ICP_NO;
		},

		schema() {
			return yup.object().shape({
				userPw: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000758')])), //{0}은(는) 팔수 입력 값 입니다. , 비밀번호
				newUserPw: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000758')])) //{0}은(는) 팔수 입력 값 입니다. , 비밀번호
					.matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/, this.getMessage_('SWCC000559')) //비밀번호는 영문, 숫자, 특수문자 3가지 조합으로 8자리 이상이여야 합니다.
			});
		},

		userId() {
			return window.atob(this.user.userId);
		}
	},

	beforeDestroy() {
		this.defaultAssign_({ key: 'isLogout', value: false }); // 화면 벗어날 경우 초기화
	},

	methods: {
		...rootMethods,

		//input 한글 입력 방지
		input(e, target) {
			this[target] = e.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '');
		},

		//비밀번호 재설정 버튼 클릭 시
		resetAction() {
			try {
				if (this.userPw === this.newUserPw) {
					this.$sf_toast({ type: 'error', message: this.getMessage_('SWCC000907') }); //다국어: 현재 비밀번호와 동일한 새 비밀번호입니다.
					return;
				} else if (this.newUserPw !== this.newUserPwCheck) {
					this.$sf_toast({ type: 'error', message: this.getMessage_('SWCC000774') }); //다국어: 새 비밀번호가 일치하지 않습니다.
					return;
				} else {
					//유효성 검사 체크
					this.schema.validateSync({ userPw: this.userPw, newUserPw: this.newUserPw });

					//사용자 비밀번호 변경 함수 호출
					this.reset();
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		//사용자 비밀번호 변경
		reset() {
			//사용자 비밀번호 변경 Action 호출
			this.passwordUpdate_({
				userPwd: this.userPw,
				newUserPwd: this.newUserPw
			})
				.then(header => {
					if (header.code === 0) {
						//로그인 후 재설정하는 경우
						if (this.user.userId && !this.isLogout) {
							this.logout();
						}

						//초기화 이메일을 통해 재설정하는 경우
						else {
							this.$router.push('/login').catch(() => {});
						}
					}

					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//로그아웃 함수
		logout() {
			this.$sf_toggleLoading(true);

			//사용자 로그아웃 Action 호출
			this.logout_()
				.then(header => {
					// 로그아웃 성공 시
					if (header.code === 0) {
						this.$sf_removeAll();
						this.$router.push('/login').catch(() => {}); //로그인 페이지로 이동
					} else {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					}
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
